export interface AdvanceSetting {
  desktop?: AdvanceSettingDevice;
  mobile?: AdvanceSettingDevice;
}

export interface AdvanceSettingDevice {
  headerElement: HeaderElementSetting;
  popupSetting: PopupSetting;
  productTagSetting: ProductTagSetting;
  feedContentSetting: FeedContentSetting;
}

export interface FeedContentSetting {
  roundedCorner: number;
  postSpacing: number;
}
export interface HeaderElementSetting {
  profilePicture: boolean;
  postsCount: boolean;
  username: boolean;
  followersCount: boolean;
  followButton: boolean;
  followingCount: boolean;
  followButtonBackground: string;
}

export interface PopupSetting {
  onPostClick: string;
  enableUserProfile: string;
}

export interface ProductTagSetting {
  onClickAction: string;
  ctaButtonText: string;
}

export enum OnPostClick {
  OpenDetailPopup = "OpenDetailPopup",
  OpenMinimalPopup = "OpenMinimalPopup"
}

export enum EnableUserProfile {
  OpenProfileInNewTab = "OpenProfileInNewTab",
  OpenProfileInSameTab = "OpenProfileInSameTab"
}

export enum OnClickAction {
  RedirectToShopifyStore = "RedirectToShopifyStore",
  PurchaseDirect = "PurchaseDirect"
}
